<script lang="ts" setup>
import type { OptionsMap } from '~/types/Product.ts';
import ExpressIcon from '~/icons/ExpressIcon.vue';

interface Props {
	title: string;
	option: string;
}

const props = defineProps<Props>();

const optionsMap: Ref<OptionsMap> = inject('optionsMap')!;
const timelineCallCount: Ref<number> = inject('timelineCallCount')!;
const showExpress = ref<boolean>(false);

watch(timelineCallCount, (newVal) => {
	if (
		// eslint-disable-next-line
		optionsMap.value.hasOwnProperty(props.option) &&
		// eslint-disable-next-line
		optionsMap.value[props.option]!.hasOwnProperty(props.title) &&
		newVal > 0
	) {
		showExpress.value = optionsMap.value[props.option]![props.title]!;
	}
});
</script>
<template>
	<div class="flex flex-row justify-center gap-md">
		{{ props?.title }}
		<ExpressIcon v-if="showExpress" />
	</div>
</template>
